import React from 'react';

const Button = ({ btntext }) => {
  return (
    <>
      <button
        className="flex place-content-center bg-white rounded-md text-sm 
                              h-6 w-16 m-1"
        style={{ border: '1px solid #fe104d' }}
      >
        {btntext}
      </button>
    </>
  );
};

export default Button;
